import http from '@/axios/http'

const post = ({ headers, data, url = '/teams' }) => {
  headers = {
    'Content-Type': 'application/json',
    ...headers
  }
  if (localStorage.getItem('token')) {
    headers.Auth = localStorage.getItem('token')
  }

  return http
    .post(
      url,
      data,
      { headers }
    )
    .then(response => response.data)
}

export const create = (team) => {
  return post({
    data: { ...team }
  })
}

export const getTeam = (info) => {
  return post({
    url: '/get_team',
    data: { ...info }
  })
}

export const update = (info) => {
  return post({
    url: '/update_team',
    data: { ...info }
  })
}

export const addMember = (info) => {
  return post({
    url: '/add_team_member',
    data: { ...info }
  })
}

export const removeMember = (info) => {
  return post({
    url: '/remove_team_member',
    data: { ...info }
  })
}

export const setImage = (info) => {
  return post({
    url: '/set_team_image',
    data: { ...info }
  })
}

export const getImage = (info) => {
  return post({
    url: '/get_team_image',
    data: { ...info }
  })
}
